var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IConfigurationRepositoryType } from '../../Configuration/IConfigurationRepository';
import { IDebugRepositoryType } from '../IDebugRepository';
import { IValidationRepositoryType } from '../../Validations/IValidationRepository';
import { IApplicationRepositoryType } from '../IApplicationRepository';
import { IGetProfilesUseCaseType } from '../../Profile/GetProfilesUseCase/IGetProfilesUseCase';
import { IGetSelectedProfileUseCaseType } from '../../Profile/GetSelectedProfileUseCase/IGetSelectedProfileUseCase';
import { ISetProfileUseCaseType } from '../../Profile/SetProfileUseCase/ISetProfileUseCase';
import { IAuthRepositoryType } from '../../Auth/IAuthRepository';
import { IUserApplicationRepositoryType } from '../../UserApplication/IUserApplicationRepository';
import { IPushNotificationsServiceType } from '../../../Services/PushNotificationsService/IPushNotificationsService';
import { IImagesRepositoryType } from '../../../Interfaces/IImagesRepository';
import { IProfileRepositoryType } from '../../Profile/IProfileRepository';
import { ICoordinatorType } from '../../../Interfaces/ICoordinator';
import { IPayloadRepositoryType } from '../../Payload/IPayloadRepository';
import { ILocalizationRepositoryType } from '../../Localization/ILocalizationRepository';
import { Observable } from '../../../../Data/Observable/Observable';
import { ICookieRepositoryType } from '../../../Interfaces/ICookieRepository';
import { ICoreEventsServiceType } from '../../../Services/CoreEventsService/ICoreEventsService';
import { IAnalyticsRepositoryType } from '../../../Interfaces/IAnalyticsRepository';
import { injectable } from '../../../../Data/Decorators/Injectable';
import { inject } from '../../../../Data/Decorators/Inject';
import { CoreConstants } from '../../../../CoreConfig';
import { I18nManager, Linking, Platform } from 'react-native';
import RNRestart from 'react-native-restart';
let InitApplicationUseCase = class InitApplicationUseCase {
    constructor(configurationRepository, debugRepository, validationRepository, applicationRepository, getProfiles, getSelectedProfile, setProfileUseCase, imagesRepository, profileRepository, userApplicationRepository, coordinator, payloadRepository, localizationRepository, analyticsRepository, cookieRepository, eventsService, pushNotificationsService, authRepository) {
        this.configurationRepository = configurationRepository;
        this.debugRepository = debugRepository;
        this.validationRepository = validationRepository;
        this.applicationRepository = applicationRepository;
        this.getProfiles = getProfiles;
        this.getSelectedProfile = getSelectedProfile;
        this.setProfileUseCase = setProfileUseCase;
        this.imagesRepository = imagesRepository;
        this.profileRepository = profileRepository;
        this.userApplicationRepository = userApplicationRepository;
        this.coordinator = coordinator;
        this.payloadRepository = payloadRepository;
        this.localizationRepository = localizationRepository;
        this.analyticsRepository = analyticsRepository;
        this.cookieRepository = cookieRepository;
        this.eventsService = eventsService;
        this.pushNotificationsService = pushNotificationsService;
        this.authRepository = authRepository;
        this.isInitializing = new Observable(false);
    }
    preloadFonts(fonts = []) {
        return this.coordinator.attachFonts(fonts);
    }
    loadFonts(fonts = []) {
        return this.configurationRepository.getFonts()
            .then(configurationFonts => ([...configurationFonts, ...fonts]))
            .then(fonts => this.applicationRepository.preloadFonts(fonts))
            .then(fonts => this.coordinator.attachFonts(fonts))
            .then(() => this.configurationRepository.loadConfigurationFonts(this.configurationRepository.configuration.value))
            .then(() => true)
            .catch(error => {
            this.debugRepository.send({
                type: 'init_application',
                data: { error }
            });
            return true;
        });
    }
    loadCache() {
        return this.applicationRepository.preloadCache()
            .then(map => Array.from(map.keys()).map(key => (Object.assign({ key }, map.get(key)))))
            .then(cache => {
            const now = Date.create().getTime();
            return Promise.all(cache.map(value => {
                if (value.expire < now) {
                    return this.applicationRepository.removeCache(value.key).catch(() => { });
                }
                return undefined;
            }));
        })
            .catch(() => ([]));
    }
    setProfile() {
        this.profileRepository.getCachedProfile().observe(this, profile => {
            profile && this.profileRepository.setProfileKeyword(profile);
        });
        const profile = this.profileRepository.getProfile().value;
        if (profile) {
            return Promise.resolve(profile);
        }
        return this.profileRepository.getProfileFromStorage()
            .then(value => this.profileRepository.setProfileKeyword(value || ''))
            .then(() => {
            const profile = this.getSelectedProfile.execute().value;
            if (profile) {
                return profile;
            }
            if (this.configurationRepository.getNamespace() === 'unit' || this.configurationRepository.getNamespace() === 'frontdesk') {
                return profile;
            }
            return this.getProfiles.execute().then(obs => {
                if (obs.value.length !== 1) {
                    return profile;
                }
                return this.setProfileUseCase.execute(obs.value[0]).value;
            });
        });
    }
    loadConfiguration() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        this.configurationRepository.configuration.observe(this, value => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
            this.coordinator.setColorScheme({
                scheme: ((_b = (_a = value === null || value === void 0 ? void 0 : value.application) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.color_scheme) || 'default',
                colors: {
                    empty_background_color: ((_e = (_d = (_c = value === null || value === void 0 ? void 0 : value.application) === null || _c === void 0 ? void 0 : _c.theme) === null || _d === void 0 ? void 0 : _d.colors) === null || _e === void 0 ? void 0 : _e.empty_background_color) || '',
                    background_gradient: (_h = (_g = (_f = value === null || value === void 0 ? void 0 : value.application) === null || _f === void 0 ? void 0 : _f.theme) === null || _g === void 0 ? void 0 : _g.colors) === null || _h === void 0 ? void 0 : _h.background_gradient,
                    background_gradient_locations: (_l = (_k = (_j = value === null || value === void 0 ? void 0 : value.application) === null || _j === void 0 ? void 0 : _j.theme) === null || _k === void 0 ? void 0 : _k.colors) === null || _l === void 0 ? void 0 : _l.background_gradient_locations,
                    background: ((_p = (_o = (_m = value === null || value === void 0 ? void 0 : value.application) === null || _m === void 0 ? void 0 : _m.theme) === null || _o === void 0 ? void 0 : _o.colors) === null || _p === void 0 ? void 0 : _p.background_color) || '',
                    primary: ((_s = (_r = (_q = value === null || value === void 0 ? void 0 : value.application) === null || _q === void 0 ? void 0 : _q.theme) === null || _r === void 0 ? void 0 : _r.colors) === null || _s === void 0 ? void 0 : _s.primary_color) || '',
                    secondary: ((_v = (_u = (_t = value === null || value === void 0 ? void 0 : value.application) === null || _t === void 0 ? void 0 : _t.theme) === null || _u === void 0 ? void 0 : _u.colors) === null || _v === void 0 ? void 0 : _v.secondary_color) || '',
                    text: ((_y = (_x = (_w = value === null || value === void 0 ? void 0 : value.application) === null || _w === void 0 ? void 0 : _w.theme) === null || _x === void 0 ? void 0 : _x.colors) === null || _y === void 0 ? void 0 : _y.text_color) || '',
                    default_text: ((_1 = (_0 = (_z = value === null || value === void 0 ? void 0 : value.application) === null || _z === void 0 ? void 0 : _z.theme) === null || _0 === void 0 ? void 0 : _0.colors) === null || _1 === void 0 ? void 0 : _1.text_color) || '',
                }
            });
        });
        this.localizationRepository.getLanguage().observe(this, lang => {
            var _a;
            const text_direction = ((_a = this.localizationRepository.getLanguages().value.find(x => x.code === lang)) === null || _a === void 0 ? void 0 : _a.text_direction) || 'ltr';
            this.coordinator.setDir(text_direction);
            if (Platform.OS !== 'web') {
                const is_rtl = text_direction === 'rtl';
                const is_platform_rtl = I18nManager.isRTL;
                if (is_rtl !== is_platform_rtl) {
                    I18nManager.forceRTL(is_rtl);
                    RNRestart.restart();
                }
            }
        });
        if (this.configurationRepository.isLoadedConfiguration.value) {
            return this.configurationRepository.getConfiguration();
        }
        if (this.payloadRepository.getDisableFetchConfiguration()) {
            this.configurationRepository.getDefaultConfiguration().observe(this, configuration => {
                const updated_configuration = this.configurationRepository.convert(configuration, true);
                this.configurationRepository.setConfiguration(updated_configuration);
                this.configurationRepository.loadConfigurationFonts(updated_configuration);
                if (!this.localizationRepository.getLanguage().value) {
                    const defaultLanguage = this.localizationRepository.getLanguages().value.find(x => x.selected);
                    defaultLanguage && this.localizationRepository.setLanguage(defaultLanguage.code);
                }
                this.imagesRepository.downloadImages(this.configurationRepository.getImages(), { preload: true })
                    .catch(error => {
                    this.debugRepository.send({
                        type: 'download_images_error',
                        data: { error }
                    });
                });
            });
            return Promise.resolve(this.configurationRepository.configuration);
        }
        const cachedConfiguration = this.configurationRepository.getCachedConfiguration();
        const defaultConfiguration = this.configurationRepository.getDefaultConfiguration().value;
        if (cachedConfiguration &&
            ((_b = (_a = defaultConfiguration.application) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.api_url) === ((_d = (_c = cachedConfiguration.application) === null || _c === void 0 ? void 0 : _c.settings) === null || _d === void 0 ? void 0 : _d.api_url) &&
            ((_f = (_e = defaultConfiguration.application) === null || _e === void 0 ? void 0 : _e.settings) === null || _f === void 0 ? void 0 : _f.application_token) === ((_h = (_g = cachedConfiguration.application) === null || _g === void 0 ? void 0 : _g.settings) === null || _h === void 0 ? void 0 : _h.application_token) &&
            ((_k = (_j = defaultConfiguration.application) === null || _j === void 0 ? void 0 : _j.settings) === null || _k === void 0 ? void 0 : _k.api_version) === ((_m = (_l = cachedConfiguration.application) === null || _l === void 0 ? void 0 : _l.settings) === null || _m === void 0 ? void 0 : _m.api_version) &&
            ((_p = (_o = defaultConfiguration.application) === null || _o === void 0 ? void 0 : _o.settings) === null || _p === void 0 ? void 0 : _p.namespace) === ((_r = (_q = cachedConfiguration.application) === null || _q === void 0 ? void 0 : _q.settings) === null || _r === void 0 ? void 0 : _r.namespace)) {
            this.configurationRepository.setConfiguration(cachedConfiguration);
            this.configurationRepository.loadConfiguration()
                .then(() => this.imagesRepository.downloadImages(this.configurationRepository.getImages(), { preload: true }))
                .catch(error => {
                if (error.code === CoreConstants.errors.invalid_profile) {
                    this.profileRepository.resetProfile();
                }
                return this.configurationRepository.getConfiguration();
            });
            return Promise.resolve(this.configurationRepository.configuration);
        }
        return this.configurationRepository.loadConfiguration()
            .then(value => {
            setTimeout(() => {
                this.imagesRepository.downloadImages(this.configurationRepository.getImages(), { preload: true });
            });
            return value;
        })
            .then(value => {
            if (!this.localizationRepository.getLanguage().value) {
                const defaultLanguage = this.localizationRepository.getLanguages().value.find(x => x.selected);
                defaultLanguage && this.localizationRepository.setLanguage(defaultLanguage.code);
            }
            return value;
        })
            .catch(error => {
            if (error.code === CoreConstants.errors.invalid_profile) {
                this.profileRepository.resetProfile();
            }
            return this.configurationRepository.getConfiguration();
        });
    }
    loadCachedImages() {
        return this.imagesRepository.getCachedImages()
            .catch((error) => {
            this.debugRepository.send({ type: 'cached_images_error', data: { error } });
            return [];
        });
    }
    batchLoad() {
        return Promise.all([this.loadBehavior(), this.loadCache(), this.configurationRepository.setDefaultConfiguration(), this.loadCachedImages(), this.cookieRepository.getCookieSettings()])
            .catch(() => []);
    }
    loadBehavior() {
        const setBehavior = (url) => {
            const behavior = this.coordinator.getBehaviorFromURL(url);
            if (!behavior) {
                return Promise.resolve(null);
            }
            return this.configurationRepository.setBehavior(behavior);
        };
        this.linkSub = Linking.addEventListener('url', ({ url }) => setBehavior(url));
        return Promise.resolve()
            .then(() => {
            return Platform.OS === 'web'
                ? window.location.href
                : Linking.getInitialURL();
        })
            .then(url => setBehavior(url))
            .then(behavior => {
            if (!behavior) {
                return this.configurationRepository.getBehaviorFromStorage()
                    .then(behavior => {
                    return behavior && this.configurationRepository.setBehavior(behavior);
                });
            }
            return behavior;
        })
            .catch(() => null);
    }
    getMustAutoInit() {
        return !this.payloadRepository.getDisableAutoInit();
    }
    getIsInitializing() {
        return this.isInitializing;
    }
    getIsInitialed() {
        return !!this.isInitialized;
    }
    loadLanguage() {
        const language = this.localizationRepository.getDefaultLanguage();
        language.observe(this, value => this.localizationRepository.setLanguage(value || ''));
        if (language.value) {
            return Promise.resolve(this.localizationRepository.getLanguage());
        }
        return this.localizationRepository.getStorageLanguage()
            .then(value => this.localizationRepository.setLanguage(value))
            .catch(() => this.localizationRepository.getLanguage());
    }
    initAnalytics(params) {
        if (!(params === null || params === void 0 ? void 0 : params.analytics)) {
            return;
        }
        this.analyticsRepository.enabledAnalytics();
        this.coordinator.onRouteChange(route => {
            if (!route.path) {
                return;
            }
            this.analyticsRepository.setViewPath(route.path, route.params);
            setTimeout(() => {
                const prev_event = this.analyticsRepository.getLastSendedScreenEvent();
                if (prev_event && prev_event.path === route.path) {
                    return;
                }
                this.analyticsRepository.sendScreenEvent({ view: route.params, path: route.path });
            }, 100);
        });
    }
    execute(params) {
        if (this.isInitialized && !(params === null || params === void 0 ? void 0 : params.force)) {
            return Promise.resolve(true);
        }
        this.isInitializing.next(true);
        this.applicationRepository.setInitParams(params);
        this.initAnalytics(params);
        return this.loadLanguage()
            .then(() => this.batchLoad())
            .then(() => this.userApplicationRepository.init())
            .then(() => this.setProfile())
            .then(() => this.loadConfiguration())
            .then(() => Promise.all([this.loadFonts(params === null || params === void 0 ? void 0 : params.fonts), this.eventsService.init()]))
            .then(() => {
            if (this.configurationRepository.getNamespace() === 'client') {
                this.validationRepository.preload();
            }
            this.isInitialized = true;
            this.isInitializing.next(false);
            return true;
        })
            .catch(error => {
            this.isInitializing.next(false);
            this.debugRepository.send({
                type: 'init_application',
                data: { error }
            });
            return true;
        });
    }
    onDestroy() {
        var _a;
        (_a = this.linkSub) === null || _a === void 0 ? void 0 : _a.remove();
    }
};
InitApplicationUseCase = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IConfigurationRepositoryType)),
    __param(1, inject(IDebugRepositoryType)),
    __param(2, inject(IValidationRepositoryType)),
    __param(3, inject(IApplicationRepositoryType)),
    __param(4, inject(IGetProfilesUseCaseType)),
    __param(5, inject(IGetSelectedProfileUseCaseType)),
    __param(6, inject(ISetProfileUseCaseType)),
    __param(7, inject(IImagesRepositoryType)),
    __param(8, inject(IProfileRepositoryType)),
    __param(9, inject(IUserApplicationRepositoryType)),
    __param(10, inject(ICoordinatorType)),
    __param(11, inject(IPayloadRepositoryType)),
    __param(12, inject(ILocalizationRepositoryType)),
    __param(13, inject(IAnalyticsRepositoryType)),
    __param(14, inject(ICookieRepositoryType)),
    __param(15, inject(ICoreEventsServiceType)),
    __param(16, inject(IPushNotificationsServiceType)),
    __param(17, inject(IAuthRepositoryType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object])
], InitApplicationUseCase);
export { InitApplicationUseCase };
